<template>
  <div>
    <div class="fl-container" v-if="isMobile">
      <div class="field">
        <div class="value">
          <span :class="['refund-label', {non:!details.isRefundable}]">{{details.isRefundable ? 'REFUNDABLE' : 'NON-REFUNDABLE'}}</span>
        </div>
      </div>
    </div>

    <div class="d-flex justify-space-between align-center margin-b-m top-info">
      <div class="field">
        <div class="f-label">BOOKING ID</div>
        <div class="value">{{details.bookingId}}</div>
      </div>
      <div class="field">
        <div class="f-label">BOOKED</div>
        <div class="value">{{details.booked}}</div>
      </div>
      <div class="field">
        <div class="f-label">AIRLINE PNR</div>
        <div class="value">{{details.pnr || '--'}}</div>
      </div>
      <div class="field" v-if="!isMobile">
        <div class="value">
          <span :class="['refund-label', {non:!details.isRefundable}]">{{details.isRefundable ? 'REFUNDABLE' : 'NON-REFUNDABLE'}}</span>
        </div>
      </div>
    </div>

    <div class="d-flex fl-container">
      <div class="fl-left">
        <div class="journey">
          <div class="f-label">
            JOURNEY DETAILS
            <span v-if="hasReturnTrip">- FIRST TRIP</span>
          </div>
          <table cellspacing="0">
            <tr class="head" v-if="isGroundAvailable(1)">
              <td>Service</td>
              <td>Pickup</td>
              <td>Dropoff</td>
              <td></td>
            </tr>
            <tr v-if="isGroundAvailable(1)">
              <td class="td-service">
                <img :src="rsvp1.img" />
                <div class="service">{{rsvp1.service}}</div>
                <a class="rsvp-link">RSVP {{rsvp1.id}}</a>
              </td>
              <td class="loc">
                <b>{{rsvp1.pickup.title || ''}}</b>
                <div class="date">{{rsvp1.pickupDate}}</div>
              </td>
              <td class="loc">
                <b>{{rsvp1.dropoff.airportCode || rsvp1.dropoff.title}}</b>
                <div class="date">{{rsvp1.eta}}</div>
              </td>
              <td class="action">
                <div class="op-btn btn-sm btn-block btn-primary btn-track" @click="trackRsvp(rsvp1.id)" v-if="details.status === 'UPCOMING'">Track RSVP</div>
                <span class="action-status">{{ rsvp1.status }}</span>
                <div class="op-btn btn-sm btn-block btn-primary btn-action" @click="showOption.rsvp1 = !showOption.rsvp1" id="action1" v-if="details.status === 'UPCOMING' && false">
                  <i class="fas fa-ellipsis-v"></i>
                </div>
                <transition name="fade-up">
                  <div class="action-list" v-if="showOption.rsvp1" id="action1">
                    <ul>
                      <li @click="trackRsvp(rsvp1.id)">
                        <i class="fas fa-map-marker-alt fa-fw"></i>
                        <span>Track RSVP</span>
                      </li>
                      <!-- <li @click="editRsvp('rsvp1')" v-if="!track.enable">
                        <i class="far fa-edit fa-fw"></i>
                        <span>Edit RSVP</span>
                      </li> -->
                    </ul>
                  </div>
                </transition>
              </td>
            </tr>

            <tr class="head">
              <td>Flight</td>
              <td>Departure</td>
              <td>Arrival</td>
              <td></td>
            </tr>
            <tr v-for="(flight, i) in details.flights.oneway" :key="i" v-if="details.flights">
              <td class="flight-name">
                <div>{{flight.flightName}}</div>
                <b>{{flight.flightCode}} - {{flight.flightNo}}</b>
              </td>
              <td class="loc">
                <b>{{flight.origin.code}}</b>
                <div>{{flight.origin.name}}</div>
                <div class="date">{{flight.origin.date}}</div>
              </td>
              <td class="loc" colspan="2">
                <b>{{flight.destination.code}}</b>
                <div>{{flight.destination.name}}</div>
                <div class="date">{{flight.destination.date}}</div>
              </td>
            </tr>

            <tr class="head" v-if="isGroundAvailable(2)">
              <td>Service</td>
              <td>Pickup</td>
              <td>Dropoff</td>
              <td></td>
            </tr>
            <tr v-if="isGroundAvailable(2)">
              <td class="td-service">
                <img :src="rsvp2.img" />
                <div class="service">{{rsvp2.service}}</div>
                <a class="rsvp-link">RSVP {{rsvp2.id}}</a>
              </td>
              <td class="loc">
                <b>{{rsvp2.pickup.airportCode || rsvp2.pickup.title}}</b>
                <div class="date">{{rsvp2.pickupDate}}</div>
              </td>
              <td class="loc">
                <b>{{rsvp2.dropoff.title || ''}}</b>
                <div class="date">{{rsvp2.eta}}</div>
              </td>
              <td class="action">
                <div class="op-btn btn-sm btn-block btn-primary btn-track" @click="trackRsvp(rsvp2.id)" v-if="details.status === 'UPCOMING'">Track RSVP</div>
                <span class="action-status">{{ rsvp2.status }}</span>
                <div class="op-btn btn-sm btn-block btn-primary btn-action" @click="showOption.rsvp2 = !showOption.rsvp2" id="action2" v-if="details.status === 'UPCOMING' && false">
                  <i class="fas fa-ellipsis-v"></i>
                </div>
                <transition name="fade-up">
                  <div class="action-list" v-if="showOption.rsvp2" id="action2">
                    <ul>
                      <li @click="trackRsvp(rsvp2.id)">
                        <i class="fas fa-map-marker-alt fa-fw"></i>
                        <span>Track RSVP</span>
                      </li>
                      <!-- <li @click="editRsvp('rsvp2')" v-if="!track.enable">
                        <i class="far fa-edit fa-fw"></i>
                        <span>Edit RSVP</span>
                      </li> -->
                    </ul>
                  </div>
                </transition>
              </td>
            </tr>
          </table>
        </div>

        <div class="journey" v-if="hasReturnTrip">
          <div class="f-label">JOURNEY DETAILS - RETURN TRIP</div>
          <table cellspacing="0">
            <tr class="head" v-if="isGroundAvailable(3)">
              <td>Service</td>
              <td>Pickup</td>
              <td>Dropoff</td>
              <td></td>
            </tr>
            <tr v-if="isGroundAvailable(3)">
              <td class="td-service">
                <img :src="rsvp3.img" />
                <div class="service">{{rsvp3.service}}</div>
                <a class="rsvp-link">RSVP {{rsvp3.id}}</a>
              </td>
              <td class="loc">
                <b>{{rsvp3.pickup.title || ''}}</b>
                <div class="date">{{rsvp3.pickupDate}}</div>
              </td>
              <td class="loc">
                <b>{{rsvp3.dropoff.airportCode || rsvp3.dropoff.title}}</b>
                <div class="date">{{rsvp3.eta}}</div>
              </td>
              <td class="action">
                <div class="op-btn btn-sm btn-block btn-primary btn-track" @click="trackRsvp(rsvp3.id)" v-if="details.status === 'UPCOMING'">Track RSVP</div>
                <span class="action-status">{{ rsvp3.status }}</span>
                <div class="op-btn btn-sm btn-block btn-primary btn-action" @click="showOption.rsvp3 = !showOption.rsvp3" id="action3" v-if="details.status === 'UPCOMING' && false">
                  <i class="fas fa-ellipsis-v"></i>
                </div>
                <transition name="fade-up">
                  <div class="action-list" v-if="showOption.rsvp3" id="action3">
                    <ul>
                      <li @click="trackRsvp(rsvp3.id)">
                        <i class="fas fa-map-marker-alt fa-fw"></i>
                        <span>Track RSVP</span>
                      </li>
                      <!-- <li @click="editRsvp('rsvp3')" v-if="!track.enable">
                        <i class="far fa-edit fa-fw"></i>
                        <span>Edit RSVP</span>
                      </li> -->
                    </ul>
                  </div>
                </transition>
              </td>
            </tr>
            <tr class="head">
              <td>Flight</td>
              <td>Departure</td>
              <td>Arrival</td>
              <td></td>
            </tr>
            <tr v-for="(flight, i) in details.flights.return" :key="i">
              <td class="flight-name">
                <div>{{flight.flightName}}</div>
                <b>{{flight.flightCode}} - {{flight.flightNo}}</b>
              </td>
              <td class="loc">
                <b>{{flight.origin.code}}</b>
                <div>{{flight.origin.name}}</div>
                <div class="date">{{flight.origin.date}}</div>
              </td>
              <td class="loc" colspan="2">
                <b>{{flight.destination.code}}</b>
                <div>{{flight.destination.name}}</div>
                <div class="date">{{flight.destination.date}}</div>
              </td>
            </tr>
            <tr class="head" v-if="isGroundAvailable(4)">
              <td>Service</td>
              <td>Pickup</td>
              <td>Dropoff</td>
              <td></td>
            </tr>
            <tr v-if="isGroundAvailable(4)">
              <td class="td-service">
                <img :src="rsvp4.img" />
                <div class="service">{{rsvp4.service}}</div>
                <a class="rsvp-link">RSVP {{rsvp4.id}}</a>
              </td>
              <td class="loc">
                <b>{{rsvp4.pickup.airportCode || rsvp4.pickup.title}}</b>
                <div class="date">{{rsvp4.pickupDate}}</div>
              </td>
              <td class="loc">
                <b>{{rsvp4.dropoff.title || ''}}</b>
                <div class="date">{{rsvp4.eta}}</div>
              </td>
              <td class="action">
                <div class="op-btn btn-sm btn-block btn-primary btn-track" @click="trackRsvp(rsvp4.id)" v-if="details.status === 'UPCOMING'">Track RSVP</div>
                <span class="action-status">{{ rsvp4.status }}</span>
                <div class="op-btn btn-sm btn-block btn-primary btn-action" @click="showOption.rsvp4 = !showOption.rsvp4" id="action4" v-if="details.status === 'UPCOMING' && false">
                  <i class="fas fa-ellipsis-v"></i>
                </div>
                <transition name="fade-up">
                  <div class="action-list" v-if="showOption.rsvp4" id="action4">
                    <ul>
                      <li @click="trackRsvp(rsvp4.id)">
                        <i class="fas fa-map-marker-alt fa-fw"></i>
                        <span>Track RSVP</span>
                      </li>
                      <!-- <li @click="editRsvp('rsvp4')" v-if="!track.enable">
                        <i class="far fa-edit fa-fw"></i>
                        <span>Edit RSVP</span>
                      </li> -->
                    </ul>
                  </div>
                </transition>
              </td>
            </tr>
          </table>
        </div>

        <div class="pax">
          <div class="f-label">PASSENGER</div>
          <table cellspacing="0">
            <thead>
              <th>Name</th>
              <th>Ticket ID</th>
              <th>Ticket Number</th>
            </thead>
            <tr v-for="(p, i) in details.pax" :key="i">
              <td>{{p.firstName}} {{p.lastName}}</td>
              <td>{{p.ticketId}}</td>
              <td>{{p.ticketNo}}</td>
            </tr>
          </table>
        </div>
      </div>

      <div class="fl-right">
        <div class="payment-box">
          <div class="f-label">PAYMENT BREAKDOWN</div>
          <table cellspacing="0">
            <tr>
              <td>Air Fare and Taxes</td>
              <td>
                <span v-if="flights.currency.code === 'USD'">$ {{priceFormat(details.airFareTotal)}}</span>
                <span v-else>{{intlFormat(flights.currency.flight)}}</span>
              </td>
            </tr>
            <tr v-if="isGroundAvailable(1)">
              <td>
                <span v-if="hasReturnTrip">LEG 1:</span>
                <b>{{shortenLoc(rsvp1.pickup)}}</b> to <b>{{shortenLoc(rsvp1.dropoff)}}</b>
              </td>
              <td>
                <span v-if="flights.currency.code === 'USD'">$ {{priceFormat(rsvp1.payment)}}</span>
                <span v-else>{{intlFormat(rsvp1.currency.total)}}</span>
              </td>
            </tr>
            <tr v-if="isGroundAvailable(2)">
              <td>
                <span v-if="hasReturnTrip">LEG 2:</span>
                <b>{{shortenLoc(rsvp2.pickup)}}</b> to <b>{{shortenLoc(rsvp2.dropoff)}}</b>
              </td>
              <td>
                <span v-if="flights.currency.code === 'USD'">$ {{priceFormat(rsvp2.payment)}}</span>
                <span v-else>{{intlFormat(rsvp2.currency.total)}}</span>
              </td>
            </tr>
            <tr v-if="hasReturnTrip && isGroundAvailable(3)">
              <td>
                LEG 3:
                <b>{{shortenLoc(rsvp3.pickup)}}</b> to <b>{{shortenLoc(rsvp3.dropoff)}}</b>
              </td>
              <td>
                <span v-if="flights.currency.code === 'USD'">$ {{priceFormat(rsvp3.payment)}}</span>
                <span v-else>{{intlFormat(rsvp3.currency.total)}}</span>
              </td>
            </tr>
            <tr v-if="hasReturnTrip && isGroundAvailable(4)">
              <td>
                LEG 4:
                <b>{{shortenLoc(rsvp4.pickup)}}</b> to <b>{{shortenLoc(rsvp4.dropoff)}}</b>
              </td>
              <td>
                <span v-if="flights.currency.code === 'USD'">$ {{priceFormat(rsvp4.payment)}}</span>
                <span v-else>{{intlFormat(rsvp4.currency.total)}}</span>
              </td>
            </tr>
            <tr v-if="details.credits">
              <td>Credits</td>
              <td>
                <span v-if="flights.currency.code === 'USD'">($ {{priceFormat(details.credits)}})</span>
                <span v-else>({{intlFormat(flights.currency.credits)}})</span>
              </td>
            </tr>
            <tr class="total">
              <td><b>TOTAL</b></td>
              <td>
                
                <span v-if="flights.currency.code === 'USD'">$ {{priceFormat(totalPayment)}}</span>
                <span v-else>{{intlFormat(totalIntl)}}</span>
              </td>
            </tr>
          </table>
        </div>

        <div :class="['op-btn btn-md btn-block margin-t-m', details.isRefundable ? 'btn-danger' : 'btn-secondary disabled']" @click="getCancelFee" v-if="details.status === 'UPCOMING' && !track.enable"> <!-- && details.isRefundable -->
          Cancel flight
        </div>
      </div>
    </div>

    <div :class="['lr-modal', {'hide': !flightAction.show}]">
      <div class="lr-box">
        Are you sure you want to cancel this flight?
        <br />
        You will have to pay a cancelation fee of <b>${{priceFormat(flightAction.cxlFee)}}</b>.
        <div class="op-btn btn-md btn-block btn-danger margin-t-m" @click="cxlFLight">
          Yes, cancel this flight
        </div>
        <div class="op-btn btn-md btn-block btn-secodary margin-t-s" @click="flightAction.show = false">
          No, I changed my mind
        </div>
      </div>
    </div>

    <unassign-driver></unassign-driver>
  </div>
</template>

<script>
/* global CONFIG */
import moment from 'moment-timezone'
import ft from '@/modules/api/featureToggle'
import ApiRsvpSearch from '@/modules/api/reservation-search'
import UnassignDriver from '@/components/SearchEdit/UnassignDriver'
import xcurrency from '@/modules/api/currency'

export default {
  name: 'flight-details',
  components: { UnassignDriver },
  data () {
    return {
      isMobile: (/Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(navigator.userAgent)),
      flightAction: {
        show: false,
        cxlFee: 0
      },
      showOption: {
        rsvp1: false,
        rsvp2: false,
        rsvp3: false,
        rsvp4: false
      },
      xcurrency: xcurrency,
      totalIntl: 0
    }
  },
  computed: {
    user () { return this.$store.state.user },
    rsvp () { return this.$store.state.reservation },
    flights () { return this.$store.state.flights },
    details () { return this.flights.selected },
    rsvp1 () { return this.flights.rsvp1 },
    rsvp2 () { return this.flights.rsvp2 },
    rsvp3 () { return this.flights.rsvp3 },
    rsvp4 () { return this.flights.rsvp4 },
    hasReturnTrip () { return this.details.roundtripId },
    totalPayment () {
      let air = this.details.airFareTotal
      // let land = parseFloat(this.rsvp1.payment) + parseFloat(this.rsvp2.payment)
      let land = 0
      if (this.isGroundAvailable(1)) land += parseFloat(this.rsvp1.payment)
      if (this.isGroundAvailable(2)) land += parseFloat(this.rsvp2.payment)
      if (this.hasReturnTrip) {
        if (this.isGroundAvailable(3)) land += parseFloat(this.rsvp3.payment)
        if (this.isGroundAvailable(4)) land += parseFloat(this.rsvp4.payment)
      }
      let credits = this.details.credits
      return (air + land) - credits
    },
    track () { return this.flights.track },
    availableGround () { return this.flights.availableGround }
  },
  methods: {
    priceFormat (data) {
      return parseFloat(data).toLocaleString('en-US', {minimumFractionDigits: 2})
    },
    trackRsvp (id) {
      let self = this
      self.$store.commit('global/setLoaderData', {show: true})

      let firstName = self.track.enable ? self.track.firstName : self.user.firstName
      let lastName = self.track.enable ? self.track.lastName : self.user.lastName
      ApiRsvpSearch.search(self, id, firstName, lastName, rsvp => {
        if (rsvp.isMtech) {
          self.$store.commit('global/setLoaderData', {show: false})
          self.$store.commit('global/setAlertData', {
            show: true,
            message: 'Tracking is not available for this reservation.'
          })
          return
        }
        if (rsvp.dispatchStatus === 'complete') {
          self.$store.commit('global/setLoaderData', {show: false})
          self.$store.commit('global/setAlertData', {
            show: true,
            message: self.$t('searchTrack.rsvpCompleted')
          })
          return
        }

        if (rsvp.dispatchStatus === 'canceled') {
          self.$store.commit('global/setLoaderData', {show: false})
          self.$store.commit('global/setAlertData', {
            show: true,
            message: self.$t('searchTrack.rsvpCancelled')
          })
          return
        }

        if (rsvp.hasExtraStop) {
          self.$sdk.get(self, `/reservations/${self.rsvpNumber}/${self.firstName}/${self.lastName}/extrastops`, {}, res => {
            if (!res.error) {
              rsvp.extraStops = res.list
              self.proceedToTrack(rsvp)
            }
          }, '1.1')
        } else {
          this.$store.commit('reservation/setCharterData', {
            enabled: false,
            pickup: {},
            startDate: '',
            endDate: '',
            selectedService: ''
          })
          if (rsvp.isCharter) {
            let starDate = moment(rsvp.pickupTime, 'MM/DD/YYYY ' + ft.timeFormat(self, false))
            self.$store.commit('reservation/setCharterData', {
              enabled: true,
              pickup: rsvp.pickup,
              startDate: starDate.format('MM/DD/YYYY hh:mmA'),
              endDate: starDate.add(rsvp.eta, 'seconds').format('MM/DD/YYYY hh:mmA'),
              selectedService: rsvp.serviceCode
            })
          }
          self.proceedToTrack(rsvp)
        }
      }, error => {
        self.$store.commit('global/setLoaderData', {show: false})
        self.$store.commit('global/setAlertData', {
          show: true,
          message: self.$t('searchTrack.rsvpDoesntExist')
        })
        console.log(error)
      })
    },
    proceedToTrack (rsvp) {
      let self = this

      self.$store.commit('global/setLoaderData', {show: false})
      self.$store.commit('rsvpTrack/setRsvp', rsvp)
      if (!document.body.classList.contains('widget-full')) {
        document.body.classList.add('widget-full');
      }

      self.$root.$router.push('rsvp-track')
      window.location = '#/rsvp-track'
    },
    getCancelFee () {
      let self = this
      self.$store.commit('global/setLoaderData', {show: true})
      self.$sdk.post2(`${CONFIG.d2dGateway}/d2d/cancelfee`, {
        token: self.user.token,
        d2dId: self.details.id
      }, res => {
        self.$store.commit('global/setLoaderData', {show: false})
        if (res.error) {
          self.$store.commit('global/setAlertData', {
            show: true,
            message: res.error.message
          })
          return
        }
        self.flightAction.cxlFee = res.amount ? parseFloat(res.amount.toFixed(2)) : 0
        self.flightAction.show = true
      })
    },
    cxlFLight () {
      let self = this
      self.flightAction.show = false
      self.$store.commit('global/setLoaderData', {show: true})
      try {
        let total = (self.totalPayment - self.flightAction.cxlFee).toFixed(2)
        self.$sdk.post2(`${CONFIG.d2dGateway}/d2d/cancel`, {
          token: self.user.token,
          d2dId: self.details.id,
          cancelGround: true,
          email: true,
          refundAmount: parseFloat(total)
        }, res => {
          self.$store.commit('global/setLoaderData', {show: false})
          if (res.error) {
            self.$store.commit('global/setAlertData', {
              show: true,
              message: res.error.message
            })
            return
          }
          self.$store.commit('global/setAlertData', {
            show: true,
            message: `Flight #${self.details.id} has been cancelled.`
          })
          self.$router.push('search')
        })
      } catch (err) {
        self.$store.commit('global/setLoaderData', {show: false})
        self.$store.commit('global/setAlertData', {
          show: true,
          message: err
        })
      }
    },
    shortenLoc (data) {
      if (data.geofenceType === 'airport') return data.airportCode
      return `${data.city}, ${data.state}`
    },
    editRsvp (target) {
      let self = this
      self.$store.commit('global/setLoaderData', {show: true})

      let firstName = self.track.enable ? self.track.firstName : self.user.firstName
      let lastName = self.track.enable ? self.track.lastName : self.user.lastName
      ApiRsvpSearch.search(self, self[target].id, firstName, lastName, rsvp => {
        self.$store.commit('reservation/setMtechData', {enabled: rsvp.isMtech || false})

        self.$store.commit('global/setLoaderData', {show: false})
        if (rsvp.dispatchStatus === 'complete') {
          self.$store.commit('global/setAlertData', {
            show: true,
            message: self.$t('searchEdit.rsvpCompleted')
          })
          return
        }

        if (rsvp.dispatchStatus === 'canceled') {
          self.$store.commit('global/setAlertData', {
            show: true,
            message: self.$t('searchEdit.rsvpCancelled')
          })
          return
        }

        if (rsvp.dispatchStatus === 'ontheway') {
          self.$store.commit('global/setAlertData', {
            show: true,
            message: self.$t('searchEdit.cannotEdit')
          })
          return
        }

        if (rsvp.dispatchStatus === 'onboard') {
          self.$store.commit('global/setAlertData', {
            show: true,
            message: self.$t('searchEdit.onboard')
          })
          return
        }

        if (rsvp.provider.ID !== null && rsvp.provider.ID !== '') {
          self.$store.commit('rsvpEdit/setUnassignRsvp', {
            id: self[target].id,
            firstName: firstName,
            lastName: lastName
          })
          self.$store.commit('rsvpEdit/showUnassignDriver')
          return
        }

        self.$store.commit('reservation/setCharterData', {
          enabled: false,
          pickup: {},
          startDate: '',
          endDate: '',
          selectedService: ''
        })
        if (rsvp.discountCode && rsvp.isCorporate) {
          self.$root.$emit('redeemCode', {code: rsvp.discountCode})
        }
        self.$store.commit('flights/setFlightEditData', {
          id: self[target].id,
          target: target
        })
        self.$store.commit('rsvpEdit/setOriginalRsvp', rsvp)
        self.$store.commit('rsvpEdit/setEditedRsvp', Object.assign({}, rsvp))
        self.$root.$router.push('rsvp-edit')
        window.location.href = '#/rsvp-edit'
      }, error => {
        self.$store.commit('global/setLoaderData', {show: false})
        self.$store.commit('global/setAlertData', {
          show: true,
          message: self.$t('searchEdit.rsvpDoesntExist')
        })
        console.log(error)
      })
    },
    isGroundAvailable (x) {
      return this.availableGround.indexOf(x) > -1
    },
    intlFormat (x, useSymbol = true) {
      x = parseFloat(x)
      return xcurrency.format({
        code: this.flights.currency.code,
        val: x.toFixed(2)
      }, true)
    }
  },
  mounted () {
    let self = this

    if (self.flights.currency && self.flights.currency.code !== 'USD') {
      self.totalIntl = parseFloat(self.flights.currency.flight)
      if (self.isGroundAvailable(1)) {
        self.totalIntl += parseFloat(self.rsvp1.currency.total)
      }
      if (self.isGroundAvailable(2)) {
        self.totalIntl += parseFloat(self.rsvp2.currency.total)
      }
      if (self.hasReturnTrip && self.isGroundAvailable(3)) {
        self.totalIntl += parseFloat(self.rsvp3.currency.total)
      }
      if (self.hasReturnTrip && self.isGroundAvailable(4)) {
        self.totalIntl += parseFloat(self.rsvp4.currency.total)
      }
      if (self.details.credits) {
        self.totalIntl -= parseFloat(self.flights.currency.credits)
      }
    }

    window.addEventListener("click", (evt) => {
      if (self.showOption.rsvp1 || self.showOption.rsvp2 || self.showOption.rsvp3 || self.showOption.rsvp4) {
        let flyoutEl = document.getElementById('action1')
        let flyoutEl2 = document.getElementById('action2')
        let flyoutEl3 = document.getElementById('action3')
        let flyoutEl4 = document.getElementById('action4')
        let targetEl = evt.target // clicked element
        do {
          if (targetEl === flyoutEl || targetEl === flyoutEl2 || targetEl === flyoutEl3 || targetEl === flyoutEl4) return
          targetEl = targetEl.parentNode
        } while (targetEl)
        if (self.showOption.rsvp1) self.showOption.rsvp1 = false
        if (self.showOption.rsvp2) self.showOption.rsvp2 = false
        if (self.showOption.rsvp3) self.showOption.rsvp3 = false
        if (self.showOption.rsvp4) self.showOption.rsvp4 = false
      }
    })
  }
}
</script>

<style lang="scss" scoped>
.field{
  // margin-bottom: 20px;
  line-height: 1;

  .value{
    font-weight: 600;
    font-size: 18px;
  }
}
.f-label{
  font-size: 11px;
  color: #888;
  font-weight: 600;
  margin-bottom: 3px;
  letter-spacing: .6px;
  line-height: 1;
}
.top-info{
  padding: 10px;
  margin-top: 10px;
  background: #fff;
  border-radius: 4px;
  border: 1px solid #aaa;
}
.refund-label{
  font-size: 12px;
  font-weight: 600;
  line-height: 1;
  padding: 5px 10px;
  background: #41b430;
  color: #fff;
  border-radius: 4px;
  letter-spacing: .6px;

  &.non{
    background: #ccc;
    color: #333;
  }
}

.fl-left{
  // width: 100%;
  flex-grow: 1;
}
.fl-right{
  width: 400px;
  padding: 0 0 0 20px;
}

.journey{
  margin: 10px 0 25px;

  &:first-child{
    margin-top: 0;
  }
  .f-label{
    margin-bottom: 5px;
  }
  table{
    border: 1px solid #999;
    width: 100%;
    background: #fafafa;

    .head{
      padding: 3px 10px;
      font-weight: 600;
      line-height: 1;
      background: #3d4759;
      color: #fff;
      font-size: 13px;
      letter-spacing: .8px;
    }
    td{
      vertical-align: top;
      padding: 7px;
      border-bottom: 1px solid #ccc;

      &:nth-child(1){
        min-width: 120px;
      }
      &:last-child{
        border-right: none;
      }
    }
    tr:not(.head) td{
      background: #fff;
    }
    tr:nth-child(even):not(.head) td{
      background: #fafafa;
    }
  }
  .rsvp-link{
    font-weight: 600;
    font-size: 13px;
    line-height: 1;
    color: #3d4759;
    cursor: default;
  }
  .td-service{
    width: 120px;
    text-align: center;

    img{
      width: 90px;
      margin: 0 auto 5px;
    }
  }
  .service{
    font-weight: 600;
    font-size: 18px;
    line-height: 1;
    border:none!important;
  }
  .flight-name{
    width: 120px;
    div{
      line-height: 1.2;
      margin-bottom: 5px;
      font-size: 14px;
      color: #777;
    }
    b{
      font-size: 18px;
    }
  }
  .loc{
    max-width: 250px;
    b{
      font-size: 16x;
      margin-bottom: 2px;
    }
    div{
      line-height: 1;
      font-size: 14px;
    }
    .date{
      margin-top: 5px;
      color: #777;
    }
  }
  .action{
    // width: 40px;
    max-width: 100px;
  }
  .btn-track{
    font-size: 14px;
    letter-spacing: .5px;
  }
  .action-status{
    display: block;
    text-align: center;
    margin-top: 7px;
    letter-spacing: .4px;
    color: #939fab;
    font-size: 14px;
    line-height: 1.2;
  }
  .btn-action{
    font-size: 18px;
  }
  .action-list{
    position: relative;

    ul{
      position: absolute;
      padding: 0;
      margin: 0;
      top: 0;
      right: 0;
      list-style: none;
      width: 125px;
      background: #fff;
      border: 1px solid #3d4759;
      border-radius: 2px;
      font-size: 14px;
      box-shadow: 1px 1px 1px rgba(0,0,0,.5);

      li{
        display: flex;
        align-items: center;
        font-weight: 600;
        padding: 5px;
        cursor: pointer;
        border-bottom: 1px solid #ccc;

        &:hover{
          background: #ebf7ff;
        }
      }
      i{
        font-size: 18px;
        margin-right: 3px;
      }
      .fa-map-marker-alt{
        color: #e52730;
      }
      .fa-edit{
        color: #2b90d8;
      }
      span{
        display: inline-block;
        line-height: 1;
      }
    }
  }
}

.pax{
  margin: 0 0 15px;

  .f-label{
    margin-bottom: 5px;
  }
  table{
    width: 100%;
    border: 1px solid  #999;
    text-align: left;
    background: #fafafa;

    th{
      padding: 3px 10px;
      border-bottom: 1px solid #ccc;
      border-right: 1px solid #ccc;
      background: #3d4759;
      color: #fff;
      font-size: 13px;
    }
    td{
      padding: 5px 10px;
      border-bottom: 1px solid #ccc;
      border-right: 1px solid #ccc;
    }
    th:last-child, td:last-child{
      border-right: none;
    }
  }
}

.payment-box{
  .f-label{
    margin-bottom: 5px;
  }
  table{
    background: #fafafa;
    width: 100%;
    border: 1px solid #999;

    td{
      padding: 5px 10px;
      border-bottom: 1px solid #ccc;
    }
    td:nth-child(1){
      color: #333;
      font-weight: 600;
      font-size: 13px;
      border-right: 1px solid #ccc;
    }
    td:nth-child(2){
      font-weight: 600;
      font-size: 16px;
      text-align: right;
      color: #444;
      word-break: break-all;
      min-width: 110px;
    }
    b{
      color: #000;
    }
    .total{
      td{
        background: #f3f3f3;
      }
      td:nth-child(2){
        color: #111;
      }
    }
  }
}

.lr-modal {
  position: fixed;
  top: 0;
  left: 0;
  z-index: 999;
  width: 100%;
  height: 100%;
  background-color: rgba(0,0,0,0.35);
  overflow: auto;
  opacity: 1;
  display: flex;
  justify-content: center!important;
  align-items: center!important;
  -webkit-transition: all 0.05s ease;
  -moz-transition: all 0.05s ease;
  -o-transition: all 0.05s ease;
  transition: all 0.05s ease;

  .lr-box {
    background: #fff;
    padding: 20px;
    border-radius: 6px;
    box-shadow: 3px 3px 2px rgba(0,0,0, .3);
    text-align: center;
    min-width: 200px;
    max-width: 420px;
    -webkit-transition: all 0.1s ease;
    -moz-transition: all 0.1s ease;
    -o-transition: all 0.1s ease;
    transition: all 0.1s ease;
  }
  .lr-alert-msg{
    margin-bottom: 20px;
    color: #45505b;
  }
  &.hide {
    z-index: -1;
    opacity: 0;
    display: none !important;

    .lr-box{
      transform: scale(90%) translateY(30px);
    }
  }
  a{
    margin-top: 10px;
  }
}

@media only screen and (max-width: 640px) {

  .field {
    .value {
      font-size: 14px;
    }
  }

  .top-info {
  }
  .fl-container {
    flex-direction: column;
    margin: 15px 0;

    .fl-right {
      padding: 0;
      width: 100%;
    }

    .journey {
      .loc {
        b {
          font-size: 13px;
        }
      }
    }
  }
}
</style>



// WEBPACK FOOTER //
// details.vue?80c15874